import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface ISiparisDurumlari_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISiparisDurumlari_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GununTarihi: any[];
  GununTarihi_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  GetSiparisDurumlari: any[];
  GetSiparisDurumlari_dummy: any[];
  isComp95250Visible: "visible" | "hidden";
  isComp455729Visible: "visible" | "hidden";
  isComp980260Visible: "visible" | "hidden";
  isComp706874Visible: "visible" | "hidden";
}

export class SiparisDurumlari_ScreenBase extends React.PureComponent<
  ISiparisDurumlari_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  siparisdurumlari_363341_value_kuikaDateRef: React.RefObject<any>;
  siparisdurumlari_227082_value_kuikaDateRef: React.RefObject<any>;
  siparisdurumlari_501002_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORD TO VIEW",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 755509,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "STATUS",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "ORDER DATE",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 515182,
          PropertyName: "title",
          Value: "B2B ORDER NUMBER",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 554145,
          PropertyName: "title",
          Value: "ERP ORDER NUMBER",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "CONFIRMED DATE",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "AMOUNT",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "ORDER NOTE",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "SENDER",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "OTHERS",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 742574,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 859329,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 398096,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 283283,
          PropertyName: "value",
          Value: "ORDER STATUS",
          TagName: "Label20_value",
        },
        {
          Id: 639057,
          PropertyName: "value",
          Value: "CHECK STATUS OF YOUR ORDER",
          TagName: "Label21_value",
        },
        {
          Id: 455729,
          PropertyName: "value",
          Value: "CONFIRMED",
          TagName: "Label5_value",
        },
        {
          Id: 980260,
          PropertyName: "value",
          Value: "PENDING",
          TagName: "Label13_value",
        },
        {
          Id: 706874,
          PropertyName: "value",
          Value: "DECLINED",
          TagName: "Label14_value",
        },
        {
          Id: 363341,
          PropertyName: "placeholder",
          Value: "STARTED DATE",
          TagName: "Date1_placeholder",
        },
        {
          Id: 227082,
          PropertyName: "placeholder",
          Value: "FINISHED DATE",
          TagName: "Date2_placeholder",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "VIEW",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontraron registros para listar",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 755509,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, Nombre del producto, Marca, Modelo, Vehículo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "Estado",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "Fecha del pedido",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 515182,
          PropertyName: "title",
          Value: "N.° de pedido B2B",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 554145,
          PropertyName: "title",
          Value: "N.° de pedido ERP",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "Fecha de aprobación",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Valor",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Nota del pedido",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Remitente",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Otro",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 742574,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 859329,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 398096,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 283283,
          PropertyName: "value",
          Value: "Estado del pedido",
          TagName: "Label20_value",
        },
        {
          Id: 639057,
          PropertyName: "value",
          Value: "Puede consultar el estado de su pedido.",
          TagName: "Label21_value",
        },
        {
          Id: 455729,
          PropertyName: "value",
          Value: "Aprobado",
          TagName: "Label5_value",
        },
        {
          Id: 980260,
          PropertyName: "value",
          Value: "Pendiente",
          TagName: "Label13_value",
        },
        {
          Id: 706874,
          PropertyName: "value",
          Value: "Rechazado",
          TagName: "Label14_value",
        },
        {
          Id: 363341,
          PropertyName: "placeholder",
          Value: "Fecha de inicio",
          TagName: "Date1_placeholder",
        },
        {
          Id: 227082,
          PropertyName: "placeholder",
          Value: "Fecha de finalización",
          TagName: "Date2_placeholder",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "Lista",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun enregistrement trouvé à afficher",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 755509,
          PropertyName: "placeholder",
          Value: "no Vaden, no OEM, nom du produit, marque, modèle, véhicule",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 501159,
          PropertyName: "title",
          Value: "Statut",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 435981,
          PropertyName: "title",
          Value: "Date de commande",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 515182,
          PropertyName: "title",
          Value: "No de commande B2B",
          TagName: "TableTemplateColumn8_title",
        },
        {
          Id: 554145,
          PropertyName: "title",
          Value: "No de commande ERP",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 197987,
          PropertyName: "title",
          Value: "Date de confirmation",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 835743,
          PropertyName: "title",
          Value: "Montant",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 687263,
          PropertyName: "title",
          Value: "Note de commande",
          TagName: "TableTemplateColumn5_title",
        },
        {
          Id: 431288,
          PropertyName: "title",
          Value: "Expéditeur",
          TagName: "TableTemplateColumn6_title",
        },
        {
          Id: 280373,
          PropertyName: "title",
          Value: "Autre",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 398096,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 283283,
          PropertyName: "value",
          Value: "Statuts de commande",
          TagName: "Label20_value",
        },
        {
          Id: 639057,
          PropertyName: "value",
          Value: "Vous pouvez connaître le statut de votre commande",
          TagName: "Label21_value",
        },
        {
          Id: 455729,
          PropertyName: "value",
          Value: "Approuvée",
          TagName: "Label5_value",
        },
        {
          Id: 980260,
          PropertyName: "value",
          Value: "En attente",
          TagName: "Label13_value",
        },
        {
          Id: 706874,
          PropertyName: "value",
          Value: "Refusée",
          TagName: "Label14_value",
        },
        {
          Id: 363341,
          PropertyName: "placeholder",
          Value: "Date de début",
          TagName: "Date1_placeholder",
        },
        {
          Id: 227082,
          PropertyName: "placeholder",
          Value: "Date de fin",
          TagName: "Date2_placeholder",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "Répertorier",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "269d3e91-5354-409c-a8c8-a79838e54cc2",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 755509,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 742574, PropertyName: "label", Value: "Turkish" },
        { Id: 859329, PropertyName: "label", Value: "English" },
        { Id: 942242, PropertyName: "label", Value: "Spanish" },
        { Id: 579363, PropertyName: "label", Value: "French" },
        { Id: 398096, PropertyName: "label", Value: "Profil" },
        { Id: 283283, PropertyName: "value", Value: "Sipariş Durumları" },
        {
          Id: 639057,
          PropertyName: "value",
          Value: "Siparişinizin hangi durumda olduğunu öğrenebilirsiniz",
        },
        { Id: 363341, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 227082, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 838301, PropertyName: "label", Value: "Listele" },
        {
          Id: 501002,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 501159, PropertyName: "title", Value: "Durum" },
        { Id: 455729, PropertyName: "value", Value: "Onaylandı" },
        { Id: 980260, PropertyName: "value", Value: "Bekliyor" },
        { Id: 706874, PropertyName: "value", Value: "Reddedildi" },
        { Id: 435981, PropertyName: "title", Value: "Sipariş Tarihi" },
        {
          Id: 653107,
          PropertyName: "value",
          Value: "[datafield:siparistarihi]",
        },
        { Id: 515182, PropertyName: "title", Value: "B2B Sip No." },
        {
          Id: 909087,
          PropertyName: "value",
          Value: "[datafield:siparisnumarasi]",
        },
        { Id: 554145, PropertyName: "title", Value: "ERP Sip No." },
        {
          Id: 762940,
          PropertyName: "value",
          Value: "[datafield:netsissiparisno]",
        },
        { Id: 197987, PropertyName: "title", Value: "Onay Tarihi" },
        { Id: 926385, PropertyName: "value", Value: "[datafield:onaytarihi]" },
        { Id: 835743, PropertyName: "title", Value: "Tutar" },
        { Id: 333682, PropertyName: "value", Value: "[datafield:parasembol]" },
        { Id: 941477, PropertyName: "value", Value: "[datafield:geneltoplam]" },
        { Id: 687263, PropertyName: "title", Value: "Sipariş Notu" },
        { Id: 342464, PropertyName: "value", Value: "[datafield:siparisnot]" },
        { Id: 431288, PropertyName: "title", Value: "Gönderen" },
        { Id: 477062, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 280373, PropertyName: "title", Value: "Diğer" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.siparisdurumlari_755509_value_kuikaTextInputRef = React.createRef();
    this.siparisdurumlari_363341_value_kuikaDateRef = React.createRef();
    this.siparisdurumlari_227082_value_kuikaDateRef = React.createRef();
    this.siparisdurumlari_501002_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetParametreler: [],
      GununTarihi: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetToplamTeklifSepeti: [],
      TriggerEvent: "",
      GetSiparisDurumlari: [],
      isComp95250Visible: "hidden",
      isComp455729Visible: "hidden",
      isComp980260Visible: "hidden",
      isComp706874Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "siparisdurumlari",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.SiparisDurumlariPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.SiparisDurumlariPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "siparisdurumlari",
      "blank_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "siparisdurumlari",
      "blank_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SiparisDurumlariPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.SiparisDurumlariPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      siparisdurumlari_363341_value:
        this.state.GununTarihi?.at?.(0)?.bugun ?? undefined,
      siparisdurumlari_227082_value:
        this.state.GununTarihi?.at?.(0)?.bugun ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SiparisDurumlariPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisDurumlari/SiparisDurumlariPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp95250Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GununTarihi = result?.data.gununTarihi;
    formVars.siparisdurumlari_363341_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );
    formVars.siparisdurumlari_227082_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );
    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.siparisdurumlari_130282_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisDurumlariPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisDurumlariPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisDurumlariPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SiparisDurumlariPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisDurumlari/SiparisDurumlariPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.siparisdurumlari_220599_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.siparisdurumlari_213318_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisDurumlariPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisDurumlariPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.SiparisDurumlariComponent_838301_onClick()) return true;

    formVars.siparisdurumlari_213318_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp95250Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisdurumlari_220599_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.siparisdurumlari_130282_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.siparisdurumlari_529921_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.siparisdurumlari_363341_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );

    formVars.siparisdurumlari_227082_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );

    stateVars.isComp455729Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisDurum"
        ),
        "1"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp980260Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisDurum"
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp706874Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisDurum"
        ),
        "2"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SiparisDurumlariComponent_755509_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisdurumlari_755509_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDurumlari",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_95250_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDurumlari",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_895762_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDurumlari",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "762891",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_742574_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_859329_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_942242_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_579363_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_398096_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDurumlari",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_838301_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      bastar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisdurumlari_363341_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      bittar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "siparisdurumlari_227082_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisDurumlari/SiparisDurumlariComponent_838301_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSiparisDurumlari = result?.data.getSiparisDurumlari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.SiparisDurumlariComponent_838301_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisDurumlariComponent_838301_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_501002 =
      stateVars.GetSiparisDurumlari ?? this.state.GetSiparisDurumlari;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDurumlariComponent_45964_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "CariKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "firmaKodu"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "SiparisNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisNumarasi"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "ParaSembol",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "paraSembol"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "SiparisDurumu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisDurum"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Kullanici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "adSoyad"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Tarih",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisTarihi"
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "not",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "siparisNot"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "OdemeTip",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "odemeTipi"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "TalepNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "talepNo"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "ToplamTutar",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "toplamTutar"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Iskonto",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "iskontoToplami"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "NetTutar",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "netTutar"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "Kdv",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "kdvTutari"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "genelToplam",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "genelToplam"
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisDetay",
      "netsisSipNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdurumlari_501002_value",
          "netsisSiparisNo"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDurumlari",
      "SiparisDetay",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "447784",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 762891, , 447784] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SiparisDurumlariPageInit();
    }
  }
}
